import i18next from 'i18next';
import PasswordValidator from './PasswordValidator';

export default class NonAlphanumericValidator extends PasswordValidator {
  constructor(passwordPolicy) {
    const { nonAlphanumericRange } = passwordPolicy;

    const { min, max } = nonAlphanumericRange;

    let translation = null;

    if (min !== undefined && max !== undefined) {
      translation = i18next.t('organization.password-rules.non-alphanumeric-constraint-1', { min, max });
    } else if (min !== undefined) {
      translation = i18next.t('organization.password-rules.non-alphanumeric-constraint-2', { min });
    } else if (max !== undefined) {
      translation = i18next.t('organization.password-rules.non-alphanumeric-constraint-3', { max });
    }

    super(nonAlphanumericRange, 'non_alphanumeric_range', false, translation);
  }

  validate(password) {
    if (this.policy) {
      const nonAlphanumericChars = password.match(/[^0-9a-zA-Z]/g);

      const min = this.policy.min ? this.policy.min : 0;
      const max = this.policy.max ? this.policy.max : 128;

      const numberNonAlphanumeric = nonAlphanumericChars ? nonAlphanumericChars.length : 0;

      if (min > numberNonAlphanumeric || max < numberNonAlphanumeric) {
        return false;
      }
    }

    return true;
  }
}
